import { AfterViewInit, Component, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../../services/modal.service';
import { GradeMaterials } from '../../models/grade-materials.model';
import { LanguageService } from '../../services/language.service';
import { PATH_TRANSLATIONS, SupportedLang } from '../../config/localized-paths';

@Component({
  selector: 'app-classroom-materials',
  templateUrl: './classroom-materials.component.html',
  styleUrls: ['./classroom-materials.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ClassroomMaterialsComponent implements AfterViewInit {
  @Input() materials!: GradeMaterials;
  @Input() gradeClass = '';

  constructor(
    public modalService: ModalService,
    private translateService: TranslateService,
    private languageService: LanguageService,
    private router: Router
  ) {}

  ngAfterViewInit(): void {
    this.languageService.applyLanguageVisibility(this.translateService.currentLang || 'en');
  }

  get orderButtonLabel(): string {
    return this.translateService.instant('grades.order_button_label');
  }

  navigateToOrderMaterials(): void {
    const lang = (this.translateService.currentLang || 'en') as SupportedLang;
    const path = PATH_TRANSLATIONS[lang]['order-materials'];
    this.router.navigate(['/', lang, path]);
  }

  getIconSrc(iconType: 'pdf' | 'doc' | 'video'): string {
    if (iconType === 'pdf') return 'assets/images/pdf_icon.png';
    if (iconType === 'video') return 'assets/images/video_icon.svg';
    return 'assets/images/doc_link.svg';
  }

  getIconTitle(iconType: 'pdf' | 'doc' | 'video'): string {
    if (iconType === 'pdf') return 'PDF';
    if (iconType === 'video') return 'Video';
    return 'Document';
  }

  getIconAlt(iconType: 'pdf' | 'doc' | 'video'): string {
    if (iconType === 'pdf') return 'PDF Icon';
    if (iconType === 'video') return 'Video Icon';
    return 'Document Icon';
  }
}
